import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Header from "../Header";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import { useParams } from "react-router-dom";
import { isMobile } from "react-device-detect";
import printJS from "print-js";
import { useSelector } from "react-redux";

const Result = () => {
    const { id } = useParams();
    const user = useSelector((state) => state.user.data);

    const [subjects, setSubjects] = useState([]);
    const [traits, setTraits] = useState([]);
    const [traitsinfo, setTraitsinfo] = useState([]);
    const [remarks, setRemarks] = useState({});

    const phone = user?.phone;
    const email = user?.email;
    const username = user?.username;
    const studid = user?.studid;
    const studclass = user?.studclass;
    const term = 'Third Term'; // Assuming term is fixed for this example, you can modify as needed
    const session = user?.session;

    axios.defaults.baseURL = id;

    const canShowResult =
        (id === "sac" && Number(traitsinfo?.exam_data?.send_status) === 1) ||
        id !== "sac";

    useEffect(() => {
        const fetchResult = async () => {
            try {
                const res = await axios.post("./v1/result/", {
                    studentid: studid,
                });

                setSubjects(res.data.scores || []);
                setTraits(
                    res.data.traits_info?.traits
                        ? Object.entries(res.data.traits_info.traits)
                        : []
                );
                setTraitsinfo(res.data.traits_info || []);
                setRemarks({
                    teacher: res.data.traits_info.test_data.teacher_comment || "",
                    next_term_start: res.data.traits_info?.traits?.resume || "",
                    // Add next_term_end if available from backend
                });
            } catch (err) {
                console.error("Error fetching result:", err);
            }
        };

        if (studid) {
            fetchResult();
        }
    }, [studid]);

    const getPrincipalComment = (average) => {
        if (average == null) return "__________________________";

        const avg = Number(average);

        if (avg >= 80) {
            return "This is an outstanding performance, keep it up.";
        } else if (avg >= 70) {
            return "This is an excellent performance, keep it up.";
        } else if (avg >= 60) {
            return "This is a very good performance, do not relent on your efforts.";
        } else if (avg >= 50) {
            return "This is a good performance, do not relent on your efforts.";
        } else if (avg >= 40) {
            return "This is a fair performance, do not relent on your efforts.";
        } else if (avg >= 30) {
            return "This is a weak performance, do not relent on your efforts.";
        } else {
            return "This is a poor performance, do not relent on your efforts.";
        }
    };

    // A third-term result can contain one, two, or all three term scores.
    // The API returns the CA and exam score for each term, so derive the
    // cumulative average from those values instead of displaying the raw
    // `cummulate` database value.
    const getCumulativeScore = (subject) => {
        const scoreFor = (ca, exam) => Number(ca || 0) + Number(exam || 0);
        const termScores = [
            scoreFor(subject.ca1, subject.exam1),
            scoreFor(subject.ca2, subject.exam2),
            scoreFor(subject.ca3, subject.exam3),
        ].filter((score) => score > 0);

        if (!termScores.length) return 0;

        return termScores.reduce((sum, score) => sum + score, 0) / termScores.length;
    };

    const formatScore = (score) => Number.isInteger(score) ? score : score.toFixed(2);
      

    const isSSS3 = studclass === "SSS3";


    return (

        <div>

            <Header />

            <Sidebar />

            <div class="docs-wrapper">
                <div class="container-fluid px-0 px-lg-8 pt-lg-14 pt-4">

                    <div className="mb-4 text-end">

                    </div>

                    {!isSSS3 && id !== 'cry' && id !== 'sac' ?
                        <div id="print-section" className="p-6 max-w-6xl mx-auto bg-white text-black rounded shadow-xl text-sm pb-8">
                            <div className="row flex justify-between items-center mb-0">
                                {id === 'cry' ? (
                                    <div className="col-8 text-start mb-0">
                                        <h1 className="text-2xl font-bold">CRYSTAL VIEW LEADMINDS</h1>
                                        <div className="text-sm">34 Tunde Alabi Crescent, Victory Estate, Ejigbo, Lagos, Nigeria</div>
                                        <div className="text-sm">Tel: 08103968795 | Email: admin@crystlviewleadminds.com</div>
                                        <div className="text-sm">Website: www.crystlviewleadminds.com</div>
                                    </div>
                                ) : id === 'ebun' ? (
                                    <div className="col-8 text-start mb-0">
                                        <h1 className="text-2xl font-bold">EBUN HERIATGE SCHOOL</h1>
                                        <div className="text-sm">Tel: 07033532505, 08144642230 | Email: admin@ebunheritageschool.com</div>
                                        <div className="text-sm">Website: www.ebunheritageschool.com</div>
                                    </div>
                                ) : id === 'sac' ? (
                                    <div className="col-8 text-start mb-0">
                                        <h1 className="text-2xl font-bold">ST AUGUSTINES SCHOOL</h1>
                                        <div className="text-sm">No. 7, St. Augustine’s School Road, off Mafon Bus Stop, Idimu</div>
                                        <div className="text-sm">Tel: 07039363384 | Email: saintaugustinesschools@gmail.com</div>
                                        <div className="text-sm">Website: www.staugustinesschools.com</div>
                                    </div>
                                ) : null}

                                <div className="col-4 text-end mb-0">
                                    <img
                                        src={"../assets/images/logo/" + id + ".png"}
                                        alt="Logo"
                                        className=""
                                        width={isMobile ? "100%" : "50%"}
                                    />
                                </div>
                            </div>

                            <div className="row mb-6">
                                <h2 className="text-lg mt-4 font-semibold mb-4">MID TERM REPORT</h2>
                                <div className="col-6">
                                    <strong>Name:</strong> {username}
                                </div>
                                <div className="col-6">
                                    <strong>Class:</strong> {studclass}
                                </div>
                                <div className="col-6">
                                    <strong>Student ID:</strong> {studid}
                                </div>
                                <div className="col-6">
                                    <strong>Term/Session:</strong> {term} - 2025/2026
                                </div>
                            </div>

                            <div className="table-responsive">
                                <table className="w-full table-auto border border-black text-xs mb-6">
                                    <thead>
                                        <tr className="bg-gray-200 text-xs">
                                            <th className="border border-black px-2 py-1">S/N</th>
                                            <th className="border border-black px-2 py-1">Subject</th>
                                            <th className="border border-black px-2 py-1">Test Score</th>
                                            <th className="border border-black px-2 py-1">Total</th>
                                            <th className="border border-black px-2 py-1">Grade</th>
                                            <th className="border border-black px-2 py-1">Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {subjects.map((subj, index) => {
                                            const total = subj.test5;

                                            let grade = '';
                                            let remark = '';

                                            // Uniform pass mark at 40 for all schools

                                            if (id === 'cry' || id === 'sac') {
                                                if (total >= 35) {
                                                    grade = 'A';
                                                    remark = 'Excellent';
                                                } else if (total >= 30) {
                                                    grade = 'B';
                                                    remark = 'Very Good';
                                                } else if (total >= 25) {
                                                    grade = 'C';
                                                    remark = 'Good';
                                                } else if (total >= 20) {
                                                    grade = 'D';
                                                    remark = 'Pass';
                                                } else {
                                                    grade = 'F';
                                                    remark = 'Poor';
                                                }
                                            } else if (id === 'ebun') {
                                                // Keep the subject type logic if you want to keep it,
                                                // but unify the passing mark at 40 for all.

                                                let subjectType = '';
                                                if (["SSS1", "SSS2", "SSS3"].includes(studclass)) {
                                                    subjectType = 'Senior';
                                                } else if (["JSS1", "JSS2", "JSS3"].includes(studclass)) {
                                                    subjectType = 'Junior';
                                                } else if (["GRADE 1", "GRADE 2", "GRADE 3", "GRADE 4", "GRADE 5", "GRADE 6"].includes(studclass)) {
                                                    subjectType = 'Primary';
                                                } else if (["NUR 1", "NUR 2", "KG 1", "KG 2", "PLAY GROUP"].includes(studclass)) {
                                                    subjectType = 'Nursery';
                                                }

                                                if (subjectType === 'Senior' || subjectType === 'Junior') {
                                                    if (total >= 18) {
                                                        grade = 'A';
                                                        remark = 'Excellent';
                                                    } else if (total >= 15) {
                                                        grade = 'B';
                                                        remark = 'Very Good';
                                                    } else if (total >= 10) {
                                                        grade = 'C';
                                                        remark = 'Good';
                                                    } else if (total >= 5) {
                                                        grade = 'D';
                                                        remark = 'Pass';
                                                    } else {
                                                        grade = 'F';
                                                        remark = 'Poor';
                                                    }
                                                } else {
                                                    // Primary and Nursery
                                                    if (total >= 18) {
                                                        grade = 'A';
                                                        remark = 'Excellent';
                                                    } else if (total >= 15) {
                                                        grade = 'B';
                                                        remark = 'Very Good';
                                                    } else if (total >= 10) {
                                                        grade = 'C';
                                                        remark = 'Good';
                                                    } else if (total >= 5) {
                                                        grade = 'D';
                                                        remark = 'Pass';
                                                    } else {
                                                        grade = 'F';
                                                        remark = 'Poor';
                                                    }
                                                }
                                            }

                                            return (
                                                <tr key={index}>
                                                    <td className="border border-black px-2 py-1 text-center">{index + 1}</td>
                                                    <td className="border border-black px-2 py-1">{subj.subject}</td>
                                                    <td className="border border-black px-2 py-1 text-center">{subj.test5}</td>
                                                    <td className="border border-black px-2 py-1 text-center">{subj.test5}</td>
                                                    <td className="border border-black px-2 py-1 text-center">{grade}</td>
                                                    <td className="border border-black px-2 py-1 text-center">{remark}</td>
                                                </tr>
                                            );
                                        })}

                                    </tbody>
                                </table>
                            </div>

                            {/* Calculate overall summary */}

                            {(() => {
                                const totalCA = subjects.reduce((acc, subj) => acc + subj.test5, 0);
                                const maxMarks = id === 'cry' ? subjects.length * 40 : subjects.length * 20 // CA only max
                                const averagePercent = maxMarks ? ((totalCA / maxMarks) * 100).toFixed(2) : "0.00";

                                return (
                                    <div className="row align-items-center mb-6">
                                        <div className="col-4 fs-4 font-semibold">
                                            Mark Obtainable: {totalCA}
                                        </div>

                                        <div className="col-4 fs-4 font-semibold">Mark Obtained: {maxMarks}</div>

                                        <div className="col-4 fs-4 font-semibold">
                                            Average:{" "}
                                            <span className="fs-t fw-medium text-dark-success">{averagePercent}%</span>
                                        </div>
                                    </div>
                                );
                            })()}

                            <div className="mb-6">
                                <p className="text-sm mb-1 font-semibold">
                                    BEHAVIOURAL TRAITS / PSYCHOMOTOR
                                </p>
                                <div className="row px-2">
                                    {traits.map(([trait1, trait2], index) => (
                                        <div
                                            key={index}
                                            className="col-6 flex items-center justify-between border border-black px-2 py-1 text-xs"
                                        >
                                            <div>{trait1}</div>
                                            <div className="border-l border-black pl-2">{trait2}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4 text-xs mt-6">
                                <div>
                                    <p>
                                        Teacher's Remarks/Comments:{" "}
                                        {remarks.teacher || "__________________________"}
                                    </p>
                                </div>
                            </div>

                            <div className="text-right text-xs mt-6">
                                {id === "cry" ? (
                                    <strong>Michael G. Ogbo (Director)</strong>
                                ) : id === "ebun" ? (
                                    <strong>Mrs A. Omiwale (Director)</strong>
                                ) : null}
                            </div>
                        </div>
                        :
                        <></>
                    }

                    {canShowResult && (
                    <div id="print-section" className="p-6 max-w-6xl mx-auto bg-white text-black rounded shadow-xl text-sm mt-5">
                        <div className="row flex justify-between items-center mb-0">
                            {id === 'cry' ?

                                <div className="col-8 text-start mb-0">
                                    <h1 className="text-2xl font-bold">CRYSTAL VIEW LEADMINDS</h1>
                                    <div className="text-sm">34 Tunde Alabi Crescent, Victory Estate, Ejigbo, Lagos, Nigeria</div>
                                    <div className="text-sm">Tel: 08103968795 | Email: admin@crystlviewleadminds.com</div>
                                    <div className="text-sm">Website: www.crystlviewleadminds.com</div>
                                </div>
                                : id === 'ebun' ?

                                    <div className="col-8 text-start mb-0">
                                        <h1 className="text-2xl font-bold">EBUN HERIATGE SCHOOL</h1>
                                        <div className="text-sm">Tel: 07033532505, 08144642230 | Email: admin@ebunheritageschool.com</div>
                                        <div className="text-sm">Website: www.ebunheritageschool.com</div>
                                    </div>
                                    : id === 'sac' ?

                                        <div className="col-8 text-start mb-0">
                                            <h1 className="text-2xl font-bold">ST AUGUSTINES SCHOOL</h1>
                                            <div className="text-sm">No. 7, St. Augustine’s School Road, off Mafon Bus Stop, Idimu</div>
                                            <div className="text-sm">Tel: 07039363384 | Email: saintaugustinesschools@gmail.com</div>
                                            <div className="text-sm">Website: www.staugustinesschools.com</div>
                                        </div>
                                        :
                                        <>

                                        </>}

                            <div className="col-4 text-end mb-0">
                                <img src={"../assets/images/logo/" + id + ".png"} alt="Logo" className="" width={isMobile ? "100%" : "50%"} />
                            </div>

                        </div>

                        <div className="row mb-6">

                            <h2 className="text-lg mt-4 font-semibold mb-4">PROGRESS REPORT</h2>

                            <div className="col-6"><strong>Name:</strong> {username}</div>
                            <div className="col-6"><strong>Class:</strong> {studclass}</div>
                            <div className="col-6"><strong>Student ID:</strong> {studid}</div>
                            <div className="col-6"><strong>Term/Session:</strong> {term} - 2025/2026</div>
                        </div>

                        <div className="table-responsive">
                            <table className="w-full table-auto border border-black text-xs mb-6">
                                    <thead>
                                        {term === 'Third Term' ? (
                                            <tr className="bg-gray-300 font-semibold text-xs text-left">
                                                <th className="border border-black px-2 py-1">S/N</th>
                                                <th className="border border-black px-2 py-1">Subject</th>
                                                <th className="border border-black px-2 py-1">First Term CA</th>
                                                <th className="border border-black px-2 py-1">First Term Score</th>
                                                <th className="border border-black px-2 py-1">Second Term CA</th>
                                                <th className="border border-black px-2 py-1">Second Term Score</th>
                                                <th className="border border-black px-2 py-1">Third Term CA</th>
                                                <th className="border border-black px-2 py-1">Third Term Score</th>
                                                <th className="border border-black px-2 py-1">Cummulate</th>
                                                <th className="border border-black px-2 py-1">Grade</th>
                                                <th className="border border-black px-2 py-1">Remarks</th>
                                            </tr>
                                        ) : (isSSS3 && term === 'Second Term') ? (
                                            <tr className="bg-gray-200 text-xs">
                                                <th className="border border-black px-2 py-1">S/N</th>
                                                <th className="border border-black px-2 py-1">Subject</th>
                                                <th className="border border-black px-2 py-1">Exam Total</th>
                                                <th className="border border-black px-2 py-1">Grade</th>
                                                <th className="border border-black px-2 py-1">Remarks</th>
                                            </tr>
                                        ) : (
                                            <tr className="bg-gray-200 text-xs">
                                                <th className="border border-black px-2 py-1">S/N</th>
                                                <th className="border border-black px-2 py-1">Subject</th>
                                                <th className="border border-black px-2 py-1">CA (40%)</th>
                                                <th className="border border-black px-2 py-1">Exam (60%)</th>
                                                <th className="border border-black px-2 py-1">Total</th>
                                                <th className="border border-black px-2 py-1">Grade</th>
                                                <th className="border border-black px-2 py-1">Remarks</th>
                                            </tr>
                                        )}
                                    </thead>
                                <tbody>
                                        {subjects.map((subj, index) => {

                                            // ✅ FIXED TOTAL CALCULATION PER TERM
                                            let total = 0;

                                            if (term === 'Second Term') {
                                                total = Number(subj.ca2) + Number(subj.exam2);
                                            } else if (term === 'Third Term') {
                                                total = getCumulativeScore(subj);
                                            } else {
                                                total = Number(subj.ca1) + Number(subj.exam1);
                                            }

                                            let grade = '';
                                            let remark = '';

                                            // Grading logic (UNCHANGED, now uses correct total)
                                            if (id === 'cry') {
                                                grade = total >= 70 ? 'A' : total >= 60 ? 'B' : total >= 50 ? 'C' : total >= 40 ? 'D' : 'P';
                                                remark = grade === 'A' ? 'Excellent' : grade === 'B' ? 'Very Good' : grade === 'C' ? 'Good' : grade === 'D' ? 'Pass' : 'Poor';
                                            } else if (id === 'sac') {
                                                if (total >= 70) {
                                                    grade = 'A'; remark = 'EXCELLENT';
                                                } else if (total >= 60) {
                                                    grade = 'B'; remark = 'VERY GOOD';
                                                } else if (total >= 50) {
                                                    grade = 'C'; remark = 'GOOD';
                                                } else if (total >= 45) {
                                                    grade = 'D'; remark = 'FAIR';
                                                } else if (total >= 40) {
                                                    grade = 'E'; remark = 'POOR';
                                                } else {
                                                    grade = 'F'; remark = 'FAIL';
                                                }
                                            } else if (id === 'ebun') {
                                                let subjectType = '';
                                                if (["SSS1", "SSS2", "SSS3"].includes(studclass)) subjectType = 'Senior';
                                                else if (["JSS1", "JSS2", "JSS3"].includes(studclass)) subjectType = 'Junior';
                                                else if (["GRADE 1", "GRADE 2", "GRADE 3", "GRADE 4", "GRADE 5", "GRADE 6"].includes(studclass)) subjectType = 'Primary';
                                                else if (["NUR 1", "NUR 2", "KG 1", "KG 2", "PLAY GROUP"].includes(studclass)) subjectType = 'Nursery';

                                                if (subjectType === 'Senior' || subjectType === 'Junior') {
                                                    if (total >= 70) { grade = 'A'; remark = 'EXCELLENT'; }
                                                    else if (total >= 60) { grade = 'B'; remark = 'VERY GOOD'; }
                                                    else if (total >= 50) { grade = 'C'; remark = 'GOOD'; }
                                                    else if (total >= 40) { grade = 'D'; remark = 'FAIR'; }
                                                    else if (total >= 30) { grade = 'E'; remark = 'POOR'; }
                                                    else { grade = 'F'; remark = 'FAIL'; }
                                                } else {
                                                    if (total >= 90) { grade = 'A+'; remark = 'OUTSTANDING'; }
                                                    else if (total >= 80) { grade = 'A'; remark = 'EXCELLENT'; }
                                                    else if (total >= 70) { grade = 'B+'; remark = 'IMPRESSIVE'; }
                                                    else if (total >= 60) { grade = 'B'; remark = 'VERY GOOD'; }
                                                    else if (total >= 50) { grade = 'C'; remark = 'GOOD'; }
                                                    else if (total >= 40) { grade = 'D'; remark = 'PASS'; }
                                                    else { grade = ''; remark = 'POOR'; }
                                                }
                                            }

                                            // ✅ THIRD TERM (UNCHANGED)
                                            if (term === 'Third Term') {
                                                return (
                                                    <tr key={index}>
                                                        <td className="border border-black px-2 py-1 text-center">{index + 1}</td>
                                                        <td className="border border-black px-2 py-1">{subj.subject}</td>

                                                        <td className="border border-black px-2 py-1 text-center">{subj.ca1}</td>
                                                        <td className="border border-black px-2 py-1 text-center">{subj.exam1}</td>

                                                        <td className="border border-black px-2 py-1 text-center">{subj.ca2}</td>
                                                        <td className="border border-black px-2 py-1 text-center">{subj.exam2}</td>

                                                        <td className="border border-black px-2 py-1 text-center">{subj.ca3}</td>
                                                        <td className="border border-black px-2 py-1 text-center">{subj.exam3}</td>

                                                        <td className="border border-black px-2 py-1 text-center font-semibold">
                                                            {formatScore(total)}
                                                        </td>

                                                        <td className="border border-black px-2 py-1 text-center">{grade}</td>
                                                        <td className="border border-black px-2 py-1 text-center">{remark}</td>
                                                    </tr>
                                                );
                                            }

                                            // ✅ SSS3 SECOND TERM (SPECIAL RULE)
                                            if (term === 'Second Term' && isSSS3) {
                                                return (
                                                    <tr key={index}>
                                                        <td className="border border-black px-2 py-1 text-center">{index + 1}</td>
                                                        <td className="border border-black px-2 py-1">{subj.subject}</td>

                                                        <td className="border border-black px-2 py-1 text-center">
                                                            {total}
                                                        </td>

                                                        <td className="border border-black px-2 py-1 text-center">{grade}</td>
                                                        <td className="border border-black px-2 py-1 text-center">{remark}</td>
                                                    </tr>
                                                );
                                            }

                                            // ✅ NORMAL SECOND TERM
                                            if (term === 'Second Term') {
                                                return (
                                                    <tr key={index}>
                                                        <td className="border border-black px-2 py-1 text-center">{index + 1}</td>
                                                        <td className="border border-black px-2 py-1">{subj.subject}</td>

                                                        <td className="border border-black px-2 py-1 text-center">{subj.ca2}</td>
                                                        <td className="border border-black px-2 py-1 text-center">{subj.exam2}</td>

                                                        <td className="border border-black px-2 py-1 text-center">
                                                            {total}
                                                        </td>

                                                        <td className="border border-black px-2 py-1 text-center">{grade}</td>
                                                        <td className="border border-black px-2 py-1 text-center">{remark}</td>
                                                    </tr>
                                                );
                                            }

                                            // ✅ FIRST TERM
                                            return (
                                                <tr key={index}>
                                                    <td className="border border-black px-2 py-1 text-center">{index + 1}</td>
                                                    <td className="border border-black px-2 py-1">{subj.subject}</td>

                                                    <td className="border border-black px-2 py-1 text-center">{subj.ca1}</td>
                                                    <td className="border border-black px-2 py-1 text-center">{subj.exam1}</td>

                                                    <td className="border border-black px-2 py-1 text-center">
                                                        {total}
                                                    </td>

                                                    <td className="border border-black px-2 py-1 text-center">{grade}</td>
                                                    <td className="border border-black px-2 py-1 text-center">{remark}</td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>

                        </div>

                        <div className="row align-items-center mb-6">
                            <div className="col-4 fs-4 font-semibold">
                                Mark Obtainable: {subjects?.length ? subjects.length * 100 : "N/A"}
                            </div>

                            <div className="col-4 fs-4 font-semibold">
                                Mark Obtained: {traitsinfo?.exam_data?.mark_obtain !== undefined
                                        ? traitsinfo.exam_data.mark_obtain
                                    : "__________________________"}
                            </div>

                            <div className="col-4 fs-4 font-semibold">
                                 Average: <span className="fs-t fw-medium text-dark-success">
                                    {traitsinfo?.exam_data?.average !== undefined
                                        ? traitsinfo.exam_data.average + "%"
                                        : "__________________________"}
                                </span>
                            </div>
                        </div>


                        <div className="mb-6">
                            <p className="text-sm mb-1 font-semibold">BEHAVIOURAL TRAITS / PSYCHOMOTOR</p>
                            <div className="row px-2">
                                {traits.map(([trait1, trait2], index) => (
                                    <div key={index} className="col-6 flex items-center justify-between border border-black px-2 py-1 text-xs">
                                        <div>{trait1}</div>
                                        <div className="border-l border-black pl-2">{trait2}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4 text-xs mt-6">
                            <div>
                                <p>Teacher's Remarks/Comments: {traitsinfo?.exam_data?.teacher_comment || "__________________________"}</p>
                            </div>
                                <div>
                                    <p>
                                        Principal's Remarks/Comments:{" "}
                                        {traitsinfo?.exam_data?.principal_comment || "__________________________"}
                                    </p>
                                </div>
                            <div>
                                <p>Next Term Begins: {traitsinfo?.exam_data?.resume || "_________________"}</p>
                            </div>
                        </div>


                        <div className="text-right text-xs mt-6">
                            {id === 'cry' ?
                                <strong>Michael G. Ogbo (Director)</strong>
                                : id === 'ebun' ?
                                    <strong>Mrs A. Omiwale (Director)</strong>
                                    :
                                    <></>
                            }
                        </div>
                    </div>
                    )}

                </div>

                <Footer />
            </div>

        </div>


    );
};

export default Result;
